// Content
export const FETCH_CONTENT_REQUEST = 'FETCH_CONTENT_REQUEST'
export const FETCH_CONTENT_SUCCESS = 'FETCH_CONTENT_SUCCESS'
export const FETCH_CONTENT_ERROR = 'FETCH_CONTENT_ERROR'
export const DESTROY_CONTENT_REQUEST = 'DESTROY_CONTENT_REQUEST'
export const DESTROY_CONTENT_SUCCESS = 'DESTROY_CONTENT_SUCCESS'
export const DESTROY_CONTENT_ERROR = 'DESTROY_CONTENT_ERROR'
export const SET_META = 'SET_META'
export const SET_CONTENT = 'SET_CONTENT'
export const PREPEND_CONTENTS = 'PREPEND_CONTENTS'
export const APPEND_CONTENTS = 'APPEND_CONTENTS'

// Content Comments
export const FETCH_CONTENT_COMMENTS_REQUEST = 'FETCH_CONTENT_COMMENTS_REQUEST'
export const FETCH_CONTENT_COMMENTS_SUCCESS = 'FETCH_CONTENT_COMMENTS_SUCCESS'
export const FETCH_CONTENT_COMMENTS_ERROR = 'FETCH_CONTENT_COMMENTS_ERROR'
export const SET_CONTENT_COMMENTS = 'SET_CONTENT_COMMENTS'

// Create Content Comment
export const CREATE_CONTENT_COMMENT_REQUEST = 'CREATE_CONTENT_COMMENT_REQUEST'
export const CREATE_CONTENT_COMMENT_SUCCESS = 'CREATE_CONTENT_COMMENT_SUCCESS'
export const CREATE_CONTENT_COMMENT_ERROR = 'CREATE_CONTENT_COMMENT_ERROR'
export const SET_NEW_COMMENT_BODY = 'SET_NEW_COMMENT_BODY'

// Contents
export const FETCH_CONTENTS_REQUEST = 'FETCH_CONTENTS_REQUEST'
export const FETCH_CONTENTS_SUCCESS = 'FETCH_CONTENTS_SUCCESS'
export const FETCH_CONTENTS_ERROR = 'FETCH_CONTENTS_ERROR'
export const SET_CONTENTS = 'SET_CONTENTS'

// Content Modal
export const SET_CONTENT_MODAL_ID = 'SET_CONTENT_MODAL_ID'
export const SET_CONTENT_MODAL_IS_VISIBLE = 'SET_CONTENT_MODAL_IS_VISIBLE'
export const SET_CONTENT_MODAL_MODE = 'SET_CONTENT_MODAL_MODE'

// Content Share Modal
export const SET_CONTENT_SHARE_MODAL_IS_VISIBLE = 'SET_CONTENT_SHARE_MODAL_IS_VISIBLE'

// Content Copy Modal
export const SET_CONTENT_COPY_MODAL_ID = 'SET_CONTENT_COPY_MODAL_ID'
export const SET_CONTENT_COPY_MODAL_IS_VISIBLE = 'SET_CONTENT_COPY_MODAL_IS_VISIBLE'

// Content Modal Modes
export const CONTENT_MODAL_MODE_LINK = 'CONTENT_MODAL_MODE_LINK'
export const CONTENT_MODAL_MODE_MANUAL = 'CONTENT_MODAL_MODE_MANUAL'

// Embedly Request
export const FETCH_URL_REQUEST = 'FETCH_URL_REQUEST'
export const FETCH_URL_SUCCESS = 'FETCH_URL_SUCCESS'
export const FETCH_URL_ERROR = 'FETCH_URL_ERROR'

// Content Form
export const CONTENT_FORM_REQUEST = 'CONTENT_FORM_REQUEST'
export const CONTENT_FORM_SUCCESS = 'CONTENT_FORM_SUCCESS'
export const CONTENT_FORM_ERROR = 'CONTENT_FORM_ERROR'
export const SET_URL_IS_FETCHED = 'SET_URL_IS_FETCHED'
export const SET_SOURCE_URL = 'SET_SOURCE_URL'
export const SET_TITLE = 'SET_TITLE'
export const SET_BODY = 'SET_BODY'
export const SET_TAGS = 'SET_TAGS'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_AUTHOR = 'SET_AUTHOR'
export const SET_SOURCE_NAME = 'SET_SOURCE_NAME'
export const SET_PUBLISHED_AT = 'SET_PUBLISHED_AT'
export const SET_FOLDER_ID = 'SET_FOLDER_ID'
export const SET_PRIORITY = 'SET_PRIORITY'
export const SET_SHAREABLE = 'SET_SHAREABLE'
export const SET_EXTERNAL = 'SET_EXTERNAL'
export const SET_ATTACHMENTS_DISPATCHED = 'SET_ATTACHMENTS_DISPATCHED'

// Content Attachments
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS'
export const SET_ATTACHMENT = 'SET_ATTACHMENT'
export const MARK_ATTACHMENT_FOR_DELETION = 'MARK_ATTACHMENT_FOR_DELETION'
export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT'

// Content Layout
export const SET_CONTENT_LAYOUT = 'SET_CONTENT_LAYOUT'
export const CONTENT_LAYOUT_GRID = 'grid'
export const CONTENT_LAYOUT_LIST = 'list'

// Content Filter
export const SET_INITIALIZED_AT_FROM = 'SET_INITIALIZED_AT_FROM'
export const SET_INITIALIZED_AT_UNTIL = 'SET_INITIALIZED_AT_UNTIL'
export const CONTENT_FILTER_REQUEST = 'CONTENT_FILTER_REQUEST'
export const CONTENT_FILTER_SUCCESS = 'CONTENT_FILTER_SUCCESS'
export const CONTENT_FILTER_ERROR = 'CONTENT_FILTER_ERROR'
export const SET_FOLDER_IDS = 'SET_FOLDER_IDS'
export const SET_TERM = 'SET_TERM'
export const SET_CREATED_AT_FROM = 'SET_CREATED_AT_FROM'
export const SET_CREATED_AT_UNTIL = 'SET_CREATED_AT_UNTIL'
export const SET_PUBLISHED_AT_FROM = 'SET_PUBLISHED_AT_FROM'
export const SET_PUBLISHED_AT_UNTIL = 'SET_PUBLISHED_AT_UNTIL'
export const SET_SORT_BY = 'SET_SORT_BY'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_PAGE = 'SET_PAGE'
export const SET_PER_PAGE = 'SET_PER_PAGE'
export const PER_PAGE_DEFAULT = 12
export const SORT_BY_DEFAULT = 'created_at'
export const SORT_DIRECTION_ASC = 'asc'
export const SORT_DIRECTION_DESC = 'desc'
export const SORT_DIRECTION_DEFAULT = SORT_DIRECTION_DESC

// Content Export
export const CONTENT_EXPORT_REQUEST = 'CONTENT_EXPORT_REQUEST'
export const CONTENT_EXPORT_SUCCESS = 'CONTENT_EXPORT_SUCCESS'
export const CONTENT_EXPORT_ERROR = 'CONTENT_EXPORT_ERROR'
export const SET_FORMAT = 'SET_FORMAT'
export const SET_STEP_INDEX = 'SET_STEP_INDEX'
export const SET_ARTICLES = 'SET_ARTICLES'
export const SELECT_ARTICLE = 'SELECT_ARTICLE'
export const SELECT_ALL_ARTICLES = 'SELECT_ALL_ARTICLES'



// WEBPACK FOOTER //
// ./src/store/modules/contents/types.js